import Attachment from './Attachment';
export default class Message {
  public ID: string = '';
  public OrganizationID: string = '';
  public Title: string = '';
  public Body: string = '';
  public Created: string = '';
  public Read!: any[];
  public Attachment!: Attachment[];
}
